<template>
    <div class="order-details--container">
        <h1>
            {{ order.marketplace.name }} Order # {{ order.order_number }}
            <div class="btn-group float-right" role="group">
                <button id="btnGroupDrop1" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Print
                </button>
                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a class="dropdown-item" href="#">Packing slips</a>
                    <a class="dropdown-item" href="#">Order Summary</a>
                    <a class="dropdown-item" href="#">Pack list</a>
                    <a target="_blank" v-if="order.metadata.label_print" class="dropdown-item" :href="order.metadata.label_print">Print Label</a>
                </div>

                <button type="button" class="btn btn-warning float-right">Update</button>
            </div>
        </h1>
        <hr>
        <div class="row">
            <div class="col-sm-8">

                <div class="row">
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-header">
                                Order Summary
                            </div>
                            <div class="card-body">
                                <table class="table borderless">
                                    <tbody>
                                    <tr>
                                        <th>Order Date</th>
                                        <td>{{formatDate(order.metadata.created_at)}}</td>
                                        <th>Currency</th>
                                        <td>{{order.metadata.currency}}</td>
                                    </tr>
                                    <tr>
                                        <th>Paid Date</th>
                                        <td>{{formatDate(order.metadata.processed_at)}}</td>
                                        <th>Product Total</th>
                                        <td>{{order.metadata.subtotal_price}}</td>

                                    </tr>
                                    <tr>
                                        <th>Hold Until</th>
                                        <td>{{order.metadata.hold}}</td>
                                        <th>Shipping Paid</th>
                                        <td><span v-if="order.shipping_lines.length">{{getShippingPaid(order.shipping_lines)}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>Ship By</th>
                                        <td>{{order.metadata.ship_by}}</td>
                                        <th>Tax Paid</th>
                                        <td>{{order.metadata.total_tax}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <th class="border-top">Total Order</th>
                                        <td class="border-top">{{order.total_price}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-header">
                                Shipping Address
                            </div>
                            <div class="card-body">
                                <p class="card-text">
                                    <strong>{{ order.shipping_address.first_name }} {{ order.shipping_address.last_name }}</strong><br>
                                    <span v-if="order.shipping_address.company">{{ order.shipping_address.company }} <br></span>
                                    {{ order.shipping_address.address }} <span v-if="order.shipping_address.address2">{{ order.shipping_address.address2 }}</span><br>
                                    {{ order.shipping_address.city }}, {{ order.shipping_address.province }} {{ order.shipping_address.postal_code }}<br>
                                    {{ order.shipping_address.country }}
                                </p>
                                <p class="card-text" v-if="order.shipping_address.phone">
                                    Phone: {{ order.shipping_address.phone }}
                                </p>
                                <p class="card-text" v-if="order.shipping_address.email">
                                    Email: {{ order.shipping_address.email }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-header">
                                Items Ordered
                            </div>
                            <div class="card-body">
                                <OrderItems :order="order" />
                            </div>
                        </div>

                        <div class="card order-activity d-none">
                            <div class="card-header">
                                Order Activity
                            </div>
                            <div class="card-body">
                                <ul class="list-group">
                                    <li href="#" class="list-group-item list-group-item-action flex-column align-items-start">
                                        <div class="d-flex w-100 justify-content-between">
                                            <h5 class="mb-1">Import</h5>
                                            <small class="text-muted">{{formatDate(order.created_at)}}</small>
                                        </div>
                                        <p class="mb-1">Order {{ order.order_number }} imported from {{ order.marketplace.name }}</p>
                                    </li>

                                    <li href="#" class="list-group-item list-group-item-action flex-column align-items-start">
                                        <div class="d-flex w-100 justify-content-between">
                                            <h5 class="mb-1">Import</h5>
                                            <small class="text-muted">{{formatDate(order.created_at)}}</small>
                                        </div>
                                        <p class="mb-1">Order {{ order.order_number }} imported from {{ order.marketplace.name }}</p>
                                    </li>
                                    <li href="#" class="list-group-item list-group-item-action flex-column align-items-start">
                                        <div class="d-flex w-100 justify-content-between">
                                            <h5 class="mb-1">Import</h5>
                                            <small class="text-muted">{{formatDate(order.created_at)}}</small>
                                        </div>
                                        <p class="mb-1">Order {{ order.order_number }} imported from {{ order.marketplace.name }}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-4">
                <div class="card">
                    <div class="card-header">
                        Shipping Info
                    </div>
                    <div class="card-body">
                        <form action="">
                        <table class="table borderless">
                            <tbody>
                            <tr v-for="shipping_line in order.shipping_lines" v-if="order.shipping_lines.length">
                                <th>Requested</th>
                                <th>{{ shipping_line.name }}</th>
                            </tr>
                            <tr>
                                <th>Weight</th>
                                <td>
                                    <input type="number" class="form-control" >
                                </td>
                            </tr>

                            <tr>
                                <th>Service</th>
                                <td>
                                    <select name="" id="" class="form-control" >
                                        <option value="">Please select</option>
                                        <option value="1">USPS First Class Mail Intl</option>
                                        <option value="1">USPS Priority Mail Intl</option>
                                        <option value="1">USPS Priority Mail Express Intl</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>Package</th>
                                <td>
                                    <select name="" id="" class="form-control" >
                                        <option value="">Package</option>
                                        <option value="1">Cubic</option>
                                        <option value="1">Flat Rate Envelope</option>
                                        <option value="1">Flat Rate Legal Envelope</option>
                                        <option value="1">Flat Rate Padded Envelope</option>
                                        <option value="1">Large Envelope or Flat</option>
                                        <option value="1">Large Flat Rate Box</option>
                                        <option value="1">Medium Flat Rate Box</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>Size</th>
                                <td>
                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            <input type="number" class="form-control" placeholder="L">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <input type="number" class="form-control" placeholder="W">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <input type="number" class="form-control" placeholder="H">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <small>(in)</small>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <th>Confirm</th>
                                <td>
                                    <select name="" id="" class="form-control" >
                                        <option value="">No Confirmation</option>
                                        <option value="1">Delivery</option>
                                        <option value="1">Signature</option>
                                        <option value="1">Adult Signature</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <th>Insurance</th>
                                <td>
                                    <select name="" id="" class="form-control" >
                                        <option value="">None</option>
                                        <option value="1">Shipsurance Discount Insurance</option>
                                        <option value="1">Carrier Insurance</option>
                                        <option value="1">Other (external)</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <th>Rate</th>
                                <td>
                                    <button type="button" class="btn btn-success btn-sm"><i class="fas fa-sync"></i> Get rate</button>
                                </td>
                            </tr>

                            <tr>
                                <th>Delivery Time</th>
                                <td>

                                </td>
                            </tr>


                            </tbody>
                        </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .borderless{
        td, th, .list-group-item {
            border: none;
        }
    }
    .order-activity{
        .list-group{
            .list-group-item{
                border-left: none;
                border-right: none;
                &:first-child{
                    border-top: none;
                }
                &:last-child{
                    border-bottom: none;
                }
            }
        }
    }
</style>
<script>
    import OrderItems from '../../components/Orders/OrderItems';
    export default {
        components : {
            OrderItems
        },
        props: [],
        data () {
            return {
                order: {
                    id: null,
                    items: [],
                    metadata: {
                        created_at: '',
                        processed_at: '',
                        total_tax: '',
                        subtotal_price: '',
                        currency: '',
                    },
                    meta: [],
                    marketplace: {
                            name: null,
                            order_number: null
                        },
                    shipping_address: {
                        address: null,
                        address2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null
                    },
                    shipping_lines: []
                },
                getMeta: function(key){
                    console.log(this.order.metadata);
                    console.log(key);
                    if( this.order.metadata.hasOwnProperty(key) ){
                    //if( typeof this.order.metadata[key] !== 'undefined' ){
                        return this.order.metadata[key];
                    }
                    return '';
                },
                getShippingPaid: function(shipping_lines){
                    let total = 0;
                    for (let line of shipping_lines) {
                        total += parseFloat(line.amount);
                    }

                    return total;
                },
                formatDate : function (date) {
                    console.log(date);
                    if( date != '' ){
                        var d = new Date(date);
                        return  d.toDateString();
                    }
                    return date;
                }
            };
        },
        created() {
            this.order.id = this.$route.params.id;
            this.fetchOrder();
        },
        methods: {
            fetchOrder: function () {
                let vm = this;
                axios.get('/orders/' + this.order.id)
                    .then(function (response) {

                        /*
                        response.data.metadata = {};

                        for (let item of response.data.meta) {
                            response.data.metadata[item.meta_key] = item.meta_value;
                        }

                        */

                        vm.order = response.data;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Show.vue